export const YoutubeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4181_12403)">
        <path
          d="M20.4 0H3.6C1.61177 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61177 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z"
          fill="white"
        />
        <path
          d="M20.0139 7.92113C19.8264 7.218 19.217 6.6555 18.5139 6.468C16.9202 6.04613 7.31078 5.99925 5.48265 6.468C4.77953 6.6555 4.17015 7.218 3.98265 7.92113C3.56078 9.70238 3.5139 14.2493 3.98265 16.0774C4.17015 16.7805 4.77953 17.343 5.48265 17.5305C7.17015 17.9993 16.7795 17.9993 18.5139 17.5305C19.217 17.343 19.8264 16.7805 20.0139 16.0774C20.4358 14.3899 20.4358 9.6555 20.0139 7.92113Z"
          fill="black"
        />
        <path d="M10.3125 9.51562V14.4844L14.6719 12" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_4181_12403">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
